// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609010336/js/" + chunkId + "." + {"44":"ce6a9b36","225":"30ff56bb","481":"955a7a0b","486":"53c9e6a0","770":"9a34e4a6"}[chunkId] + ".0.2931003282236532.chunk.js";
};